<template>
  <swatches v-model="colorVal"
            :colors="filament ? filamentColors : colors"
            :show-border="showBorder"
            :shapes="shapes"
            :max-height="maxHeight"
            :swatch-size="swatchSize"
            :trigger-style="triggerInlineStyle"
            :disabled="disabled"
            class="clr-pick">
  </swatches>
</template>

<script>
  import Swatches from 'vue-swatches';
  import "vue-swatches/dist/vue-swatches.min.css"

  export default {
    name: 'color-picker',
    components: {
      Swatches
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      filament: {
        type: Boolean,
        default: false
      },
      showBorder: {
        type: Boolean,
        default: true
      },
      showTriggerBorder: {
        type: Boolean,
        default: true
      },
      shapes: {
        type: String,
        default: 'squares'
      },
      maxHeight: {
        type: Number,
        default: 300
      },
      size: {
        type: String,
        default: 'medium'
      },
      triggerSize: {
        type: String,
        default: 'medium'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      triggerStyle: {
        type: Object,
        require: false
      }
    },
    data() {
      return {
        colors: ['#7bd148', '#5484ed','#0D93EC', '#08a2b5', '#46d6db', '#7ae7bf', '#51b749', '#fbd75b', '#ffb878', '#fa857a', '#dc2127', '#dbadff', '#e1e1e1', ''],
        filamentColors: ['#ffffff', '#000000', '#F44336', '#2196F3', '#FFEB3B', '#4CAF50', '#F06292', '#FF9800', '#9C27B0', '#FFFDE7', '#9E9E9E', '#800000', '']
      }
    },
    computed: {
      colorVal: {
        get() {
          return this.value == '#ff887c' ? '#0D93EC' : this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
      },
      swatchSize() {
        switch (this.size) {
          case 'small': return 24;
          case 'large': return 42;
          default: return 32;
        }
      },
      triggerSizeStyle() {
        switch (this.triggerSize) {
          case 'small': return {width: '24px', height: '24px'};
          case 'large': return {width: '42px', height: '42px'};
          default: return {width: '32px', height: '32px'};
        }
      },
      triggerInlineStyle() {
        let defaultStyle = this.triggerSizeStyle;
        if (this.showTriggerBorder) {
          defaultStyle.boxShadow = 'inset 0 0 2px rgba(0,0,0,.75)';
        }
        if (this.triggerStyle) {
          return Object.assign(defaultStyle, this.triggerStyle)
        }

        return defaultStyle;
      }
    }
  }
</script>

<style lang="scss">

</style>
